module.exports = __webpack_public_path__ + "img/img2.5a8bb031.jpg";